import React from "react";
import Navbar from "../Components/Navbar";
import Commodity from "../Assets/Commodities.jpg";
import Office from "../Assets/Office.jpg";
import { Link } from "react-router-dom";
import Features from "../Components/Features";
import Footer from "../Components/Footer";

function Commodities() {
  return (
    <div>
      <Navbar />
      <div className="w-full text-white pb-10">
        <div className="px-4 pb-10 mt-[66px] max-w-[1330px] mx-auto  bg-[#024415D8] rounded-[50px]">
          <div className="flex justify-center">
            <h1 className="mt-8 mx-auto text-center text-4xl md:text-7xl font-bold">
              AGROVEST Commodities
            </h1>
          </div>
        </div>
        <div className="py-20 px-4 h-[90vh] md:h-[30vh] lg:h-[70vh]">
          <div className="max-w-[1240px] mx-auto grid md:grid-cols-2">
            <img
              className="w-[500px] mx-auto my-4 rounded-[20px]"
              src={Commodity}
              alt="img"
            />
            <div className="flex flex-col justify-center">
              <h1 className="text-green-900 font-bold md:text-6xl md:mx-3 sm:text-4xl text-3xl">
                Trade CFD's on Commodities
              </h1>

              <p className="p-3 text-[rgb(111,111,111)] font-bold">
                Create a trader account in a couple of minutes to start CFD
                trading of liqiud energy resource (Oil and Gas).
              </p>

              <h4 className="underline font-bold text-green-900 p-3">
                <Link to="/register" className="link">
                  Open Account
                </Link>
              </h4>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-[4rem] md:h-[30vh] lg:h-[60vh] h-[110vh]">
          <div className="max-w-[1240px] mx-auto grid sm:grid-cols-2 md:grid-cols-3 gap-8">
            <div className="shadow-xl flex flex-col p-2 my-4 rouded-lg text-green-100">
              <h1 className="font-bold text-green-900 text-2xl">
                Wide Order Settings
              </h1>
              <p className="font-bold text-[rgb(111,111,111)] p-3">
                One of the world's largest aggregators of liquidity with
                accurate and stable data transfer to partner brokers.
              </p>
            </div>

            <div className="shadow-xl flex flex-col p-2 my-4 rouded-lg text-green-100">
              <h1 className="font-bold text-green-900 text-2xl">
                Tight Spreads Even During A "lull"
              </h1>
              <p className="font-bold text-[rgb(111,111,111)] p-3">
                The brokerage company always manages to maintain a low level of
                spreads even with low market volatility.
              </p>
            </div>

            <div className="shadow-xl flex flex-col p-2 my-4 rouded-lg text-green-100">
              <h1 className="font-bold text-green-900 text-2xl">
                The Maximum Accuracy Of Order Execution
              </h1>
              <p className="font-bold text-[rgb(111,111,111)] p-3">
                Deals with commodities that are processed up to 50 milliseconds
                without failures, requotes and slippages.
              </p>
            </div>
          </div>
        </div>
        <Features />

        <div className="py-16 w-full px-4 h-[110vh] md:h-[30vh] lg:h-[80vh]">
          <div className="max-w-[1240px] mx-auto grid md:grid-cols-2 gap-8">
            <div className="flex flex-col justify-center">
              <h1 className="text-green-900 font-bold md:text-6xl sm:text-4xl text-3xl">
                Trade CFD's on CryptoCurrency
              </h1>
              <p className="p-3 text-[rgb(111,111,111)] font-bold">
                Decentralized digital currencies are available for online
                trading with credit leverage. Choose the most popular
                instruments in this category, including Bitcoin and numerous
                altcoins.
              </p>
              <h4 className="underline font-bold text-green-900 p-3">
                <Link to="/register" className="link">
                  Open Account
                </Link>
              </h4>
            </div>
            <img
              className="w-[600px] mx-auto my-4 rounded-[20px]"
              src={Office}
              alt="img"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Commodities;
